import { Request } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useFind: useUserTeams,
  useDelete: useUserTeamDelete,
  useUpdate: useUserTeamsUpdate,
} = getCRUDHooks({
  entityName: 'userTeam',
  update: (newTeams, { userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).teams.update('', newTeams),
  find: ({ userId, filters }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).teams.find(filters),
  remove: /* istanbul ignore next */ ({ teamId, userId }) => {
    // FIXME: use api when available
    const request = new Request(`/ajax/teams/${teamId}/users/${userId}`, 'DELETE');
    return request.execute();
  },
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserTeams,
  useUserTeamDelete,
  useUserTeamsUpdate,
};
